module.exports = __webpack_public_path__ + "static/photo2-dc97ff28b450b253a6f3e222af41186c.jpg";